import { render } from "./fieldCustomSelect.vue?vue&type=template&id=31f6745a"
import script from "./fieldCustomSelect.vue?vue&type=script&lang=js"
export * from "./fieldCustomSelect.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__